export default [
  'React makes it painless to create interactive UIs',
  'React-typout is a simple component that types by itself'
];



/** WEBPACK FOOTER **
 ** ./docs/sentences.js
 **/